import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibTickIconV2Component } from './lib-tick-icon-v2.component';

@NgModule({
  declarations: [LibTickIconV2Component],
  imports: [CommonModule],
  exports: [LibTickIconV2Component],
})
export class LibTickIconV2Module {}
